import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const southVeniceConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'South Venice Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in South Venice, FL. Sam\'s Tree Service handles hazardous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_south_venice',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving South Venice',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in South Venice Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the tree jobs that other companies 
     won't take on in <strong>South Venice</strong>. Mature trees, dense canopies, and 
     Florida's storm season create real hazards for residential properties and our team 
     has the training and equipment to manage them safely. Whether it's branches over your 
     roof, roots lifting your driveway, or a leaning trunk threatening your home, we deliver 
     expert solutions at a fair price.`,

    `We specialize in <strong>hazardous and overgrown tree situations</strong> storm split 
     limbs, diseased or rotting sections, dangerously leaning trees, and thick overgrowth 
     pressing against structures or power lines. From targeted pruning to full removal, 
     we tailor every service to your specific landscape.`,

    `<strong>Sam's Tree Service</strong> brings dependable, professional tree care to 
     <strong>South Venice</strong> and surrounding communities throughout 
     <strong>Sarasota and Venice</strong>, keeping your yard safe and your trees in top health.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'South Venice, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SouthVenice = () => <LocationPage config={southVeniceConfig} />;
export default Services_SouthVenice;
